"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _commonCta = require("@mmc/common-cta");
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _navigationHeader = _interopRequireDefault(require("../styles/navigation-header.css"));
var dataUtils = new _mmcDataUtilities["default"]();
var appendImageTransforms = dataUtils.appendImageTransforms;
var PromotionLink = function PromotionLink(_ref) {
  var header = _ref.header,
    description = _ref.description,
    image = _ref.image,
    mobileImage = _ref.mobileImage,
    ctalabel = _ref.ctalabel,
    ctaLink = _ref.ctaLink,
    theme = _ref.theme,
    mobileNavActive = _ref.mobileNavActive;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _navigationHeader["default"].promotionCard
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _navigationHeader["default"].promotionCardText
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _navigationHeader["default"].labelText
  }, header), /*#__PURE__*/_react["default"].createElement("div", {
    className: _navigationHeader["default"].promotionCardHeading
  }, description), ctalabel && /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    data: {
      label: ctalabel,
      url: ctaLink,
      priority: 'low'
    },
    classes: [_navigationHeader["default"].promoCardLink, theme.dark]
  })), mobileNavActive && mobileImage != null && mobileImage.image ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _navigationHeader["default"].promtionCardImage,
    style: {
      backgroundImage: "url(\"" + appendImageTransforms(mobileImage.image) + "\")"
    }
  }) : (image == null ? void 0 : image.image) && /*#__PURE__*/_react["default"].createElement("div", {
    className: _navigationHeader["default"].promtionCardImage,
    style: {
      backgroundImage: "url(\"" + appendImageTransforms(image.image) + "\")"
    }
  }));
};
PromotionLink.displayName = 'PromotionLink';
var _default = exports["default"] = PromotionLink;